"use client";

import React, { useState, useEffect } from "react";
import Header from "../components/Header/Header";
import Services from "../components/Services/Services";
import HairdresserList from "../components/HairdresserCard/HairdresserList";
import ReservedTimes from "../components/Reserved/ReservedTimes";
import CancelReservationModal from "../components/Modals/CancelReservationModal";
import ReservationTimeoutModal from "../components/Modals/ReservationTimeoutModal";

const MainPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);

  useEffect(() => {
    const modalTime = localStorage.getItem("showModalTime");

    if (modalTime) {
      const timeLeft = Number(modalTime) - Date.now();

      if (timeLeft <= 0) {
        setShowTimeoutModal(false);
      } else {
        setTimeout(() => {
          setShowTimeoutModal(false);
        }, timeLeft);
      }
    }
  }, []);

  useEffect(() => {
    document.body.classList.add("main-page-safe-area-extend");

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      document.body.classList.add("is-ios");
    }

    return () => {
      document.body.classList.remove("main-page-safe-area-extend");
      document.body.classList.remove("is-ios");
    };
  }, []);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };


  return (
    <>
      <Header onSearch={handleSearch} />
      <div
        style={{
          paddingTop: "max(env(safe-area-inset-top, 0px) + var(--header-ios), var(--header-android))",
        }}
      >
        <CancelReservationModal
          isOpen={showCancelModal}
          onClose={() => setShowCancelModal(false)}
        />
        <ReservationTimeoutModal
          isOpen={showTimeoutModal}
          onClose={() => setShowTimeoutModal(false)}
          onReserveAgain={() => {
            setShowTimeoutModal(false);
            console.log("رزرو مجدد انجام شد!");
          }}
        />

        <section className="px-3 px-md-4 pb-1 pb-md-8">
          <ReservedTimes />
        </section>

        <section style={{ padding: "0", margin: "0" }}>
          <Services searchQuery={searchQuery} />
        </section>

        <section className="pb-2" style={{ padding: "0", margin: "0" }}>
          <HairdresserList searchQuery={searchQuery} />
        </section>
      </div>
    </>
  );
};

export default MainPage;
